import React from 'react'
import {BrigadeInfo, DiagnoseInfo, PatientInfo} from "../components";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import {customerEndErCallFromHospitalizationFrom, endErCallFromHospitalizationFrom} from '../../requests/er-thunk'
import { PanelFooter, Spinner } from '../../../shared'
import { Button } from '../../../ui-components'
import { ER_CALL_STATUSES } from '../../../services/constants'
import CustomerDpInfo from "../../sentry/CustomerDpInfo";
import DpEmergencyPatientInfo from "../DpEmergencyComponents/DpEmergencyPatientInfo"
import PayInfoDp from "../../sentry/DpComponents/PayInfoDp";

const HospitalizationRequest = () => {
  const dispatch = useAppDispatch()
  const {request, pool, er_call} = useAppSelector(state => state.requests)

  return (
    <div id='hospitalization-request' className='request-info-container'>
      <div className="wrapper">
        <div className='info-wrapper'>
          <p>Ожидание подтверждения госпиталя</p>
          {/*<span onClick={() => dispatch(changeErCallStatus(4))}>Отменить</span>*/}
        </div>
        <Spinner/>
      </div>
      <PayInfoDp/>
      <DiagnoseInfo/>
      <BrigadeInfo/>
      {request && request.type ===3 && <CustomerDpInfo/>}
      <DpEmergencyPatientInfo br={request}/>
      {/*<PatientInfo/>*/}
      <PanelFooter className='footer'>
        <Button type='outlined' className={'width-40'} onClick={() => dispatch(customerEndErCallFromHospitalizationFrom(ER_CALL_STATUSES.endedLeftInPlace))} >На месте</Button>
        <Button type='outlined' className={'width-40'} onClick={() => dispatch(customerEndErCallFromHospitalizationFrom(ER_CALL_STATUSES.endedRefusedHospital))}>Отказ от Гсп.</Button>
      </PanelFooter>
    </div>
  )
}

export default HospitalizationRequest
